import React, {Component} from 'react';
import {Button, Form, Message, Modal} from "semantic-ui-react";
import {uiFlowBenAdmin} from "../utils/common";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {CustomDivider, CustomEmailInput, CustomModalHeader} from "./custom-common";
import {SubmitCaseRequest} from "../services/types";
import {submitCase} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const {user:{firstName, lastName}, initialData: {uiFlow, email}} = state;

    return {
        isBenAdmin: uiFlow === uiFlowBenAdmin,
        firstName, lastName, email, uiFlow,
        ...ownProps
    }
};

class GetHelpModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subject: '',
            message: '',
            email: '',
            phone: '',
            loading: false,
            submitError: '',
            fullName: '',
            emailValidationError: '',
        };
    }

    handleSubmit = async () => {
        const {subject, message, email, phone, isBenAdmin, fullName: benAdminFullName} = this.state;
        const {employerId, firstName, lastName, email: standaloneEmail, uiFlow} = this.props;
        let payloadEmail = standaloneEmail;
        let fullName = `${firstName} ${lastName}`;
        if(isBenAdmin){
            payloadEmail = email;
            fullName = benAdminFullName;
        }
        this.setState({loading: true, error: null});
        try {
            const payload = new SubmitCaseRequest ({
                email: payloadEmail,
                name: fullName,
                subject,
                message,
                employerId,
                phone,
                uiFlow,
            });
            await submitCase(payload);
            this.setState({loading: false});
            this.onClose()
        } catch (e) {
            this.setState({loading: false, submitError: "Unable to submit your message"});
        }
    }

    onClose() {
        this.props.onModalClose();

        this.setState({
            subject: '',
            message: '',
            email: '',
            phone: '',
            fullName: '',
            submitError: '',
            emailValidationError: '',
        })
    }

    render(){
        const {displayCoveredModal, localization, isBenAdmin} = this.props;
        const {subject, message, submitError, loading, email, phone, fullName} = this.state;
        const strings = localization.getHelp;

        return (
            <Modal style={{width: '520px'}} onClose={() => this.onClose()} open={displayCoveredModal} >
                <CustomModalHeader title={strings.title} onClose={() => this.onClose()}/>
                <Modal.Content className={"small"}>
                    <span>{strings.descr}</span>

                    <Form className={'formGetHelpModal'}>

                        {isBenAdmin && <React.Fragment>
                            <Form.Field label={`${strings.contactPreference}*`}/>
                            <Form.Field>
                                <CustomEmailInput required value={email} placeholder={strings.email} style={{margin: 0}}
                                            onChange={(event, {value}) => {
                                                this.setState({email: value});
                                            }}
                                />
                            </Form.Field>

                            <div style={{marginTop: '0.5em', marginBottom: '0.5em'}}>{strings.or}</div>

                            <Form.Input value={phone}
                                        placeholder={strings.phone}
                                        onChange={(e, {value})=>this.setState({phone: value})}/>

                            <Form.Group widths={'equal'}>
                                <Form.Input label={strings.fullName} required value={fullName}
                                            onChange={(e, {value})=>this.setState({fullName: value})}/>

                                <Form.Input label={strings.subject} required
                                            value={subject}
                                            onChange={(e, {value})=>this.setState({subject: value})}/>
                            </Form.Group>
                        </React.Fragment>
                        }
                        {!isBenAdmin &&
                        <Form.Input label={strings.subject} required
                                    value={subject}
                                    onChange={(e, {value}) => this.setState({subject: value})}/>
                        }

                        <Form.Field>
                            <Form.TextArea rows={10} style={{height: "173px", resize: "none"}} label={strings.message} value={message}
                                           onChange={(e, {value}) => this.setState({message: value})}
                                           required/>
                            <div className={'spanishGetHelpText'}>
                                {strings.spanishHelp}
                            </div>
                        </Form.Field>

                        {!!submitError && <div><Message negative style={{margin: '0.8em'}}>{submitError}</Message></div>}
                        <CustomDivider hidden/>
                        <CustomDivider small hidden/>
                        <div style={{textAlign: 'right'}}>
                        <Button className={'emptyButton'} onClick={() => this.onClose()}>{strings.cancel}</Button>
                        <Button primary disabled={ subject.length === 0 || message.length === 0 || (!!isBenAdmin && (fullName.length === 0 || (email.length === 0 && phone.length === 0)))}
                                loading={loading}
                                onClick={this.handleSubmit}>{strings.submit}</Button>
                        </div>
                    </Form>
                </Modal.Content>
            </Modal>
        )
    }
}

export default withRouter(connect(mapStateToProps)(GetHelpModal));

